/* WSP v4.86: destination hints and safe, bounded public requests.
 * No raw IP storage, market changes, customer data storage or carrier scraping.
 */
(function () {
  'use strict';
  var copyNode = document.getElementById('wsp-delivery-copy');
  var copy = {};
  try { copy = JSON.parse(copyNode ? copyNode.textContent : '{}'); } catch (ignore) {}
  function t(key) { return String(copy[key] || ''); }
  function esc(value) { return String(value == null ? '' : value).replace(/[&<>"']/g, function(c) { return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]; }); }
  function requestJson(url, timeout, sameOrigin) {
    var controller = typeof AbortController === 'function' ? new AbortController() : null;
    return new Promise(function (resolve, reject) {
      var done = false;
      var timer = setTimeout(function () {
        if (done) return;
        done = true;
        reject(new Error('request_timeout'));
        if (controller) controller.abort();
      }, timeout || 12000);
      fetch(url, {signal: controller ? controller.signal : undefined, credentials: sameOrigin ? 'same-origin' : 'omit', referrerPolicy:'no-referrer', cache:'no-store'})
        .then(function(r) { if (!r.ok) throw new Error('request_http_' + r.status); return r.json(); })
        .then(function(data) { if (!done) { done = true; clearTimeout(timer); resolve(data); } }, function(error) { if (!done) { done = true; clearTimeout(timer); reject(error); } });
    });
  }
  var countryPromise;
  function detectCountry() {
    if (!countryPromise) {
      var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || (window.WSP && WSP.rootUrl) || '/';
      if (root.charAt(0) !== '/' || root.indexOf('//') === 0) root = '/';
      if (root.slice(-1) !== '/') root += '/';
      countryPromise = requestJson(root + 'browsing_context_suggestions.json?country[enabled]=true', 2500, true)
        .then(function(data) { var c = data && data.detected_values && data.detected_values.country; return c && /^[A-Z]{2}$/.test(c.handle) ? c.handle : ''; })
        .catch(function() { return ''; });
    }
    return countryPromise;
  }
  function cttUrl(code) {
    var c = encodeURIComponent(code);
    return 'https://appserver.ctt.pt/CustomerArea/PublicArea_Detail?ObjectCodeInput=' + c + '&SearchInput=' + c + '&IsFromPublicArea=true';
  }
  // Only official postal services. Where a deep link is not verified, open
  // the official search form and keep the reference displayed for copying.
  var carriers = {
    US:['USPS', 'https://tools.usps.com/go/TrackConfirmAction?tLabels=', true],
    GB:['Royal Mail', 'https://www.royalmail.com/track-your-item#/tracking-results/', true],
    DE:['Deutsche Post', 'https://www.deutschepost.de/sendung/simpleQuery.html?form.sendungsnummer=', true],
    FR:['La Poste', 'https://www.laposte.fr/outils/suivre-vos-envois', false],
    ES:['Correos', 'https://www.correos.es/es/es/herramientas/localizador/envios', false],
    IT:['Poste Italiane', 'https://www.poste.it/cerca/index.html', false],
    CA:['Canada Post', 'https://www.canadapost-postescanada.ca/track-reperage/en', false],
    AU:['Australia Post', 'https://auspost.com.au/mypost/track/overview', false],
    NL:['PostNL', 'https://www.postnl.nl/en/receiving/parcels/track-and-trace/', false],
    BE:['bpost', 'https://track.bpost.cloud/btr/web/#/home', false],
    IE:['An Post', 'https://www.anpost.com/Post-Parcels/Track/Search', false],
    AT:['Österreichische Post', 'https://www.post.at/sendungsverfolgung', false],
    SE:['PostNord', 'https://www.postnord.se/en/our-tools/track-and-trace/', false],
    DK:['PostNord', 'https://www.postnord.dk/en/tools/track-and-trace', false],
    FI:['Posti', 'https://www.posti.fi/en/tracking', false],
    NO:['Posten', 'https://www.posten.no/en/tools', false],
    CH:['Swiss Post', 'https://www.post.ch/en/receiving-mail/track-consignments', false],
    NZ:['NZ Post', 'https://www.nzpost.co.nz/tools/tracking', false],
    JP:['Japan Post', 'https://trackings.post.japanpost.jp/services/srv/search/input?locale=en', false],
    RO:['Poșta Română', 'https://www.posta-romana.ro/track-trace.html', false],
    SG:['SingPost', 'https://www.singpost.com/track-items', false],
    BR:['Correios', 'https://rastreamento.correios.com.br/app/index.php', false],
    PL:['Poczta Polska', 'https://emonitoring.poczta-polska.pl/', false]
  };
  function carrierFor(country, code) {
    if (country === 'PT') return {name:'CTT', url:cttUrl(code), prefilled:true};
    var c = carriers[country];
    return c ? {name:c[0], url:c[1] + (c[2] ? encodeURIComponent(code) : ''), prefilled:c[2]} : null;
  }
  function usNotice() { return '<div class="wsp-delivery-note wsp-delivery-note--compact"><strong>' + esc(t('us_title')) + '</strong><p>' + esc(t('us_body')) + '</p></div>'; }
  window.WSPDelivery = {t:t, esc:esc, requestJson:requestJson, detectCountry:detectCountry, carrierFor:carrierFor, cttUrl:cttUrl, usNotice:usNotice};

  // Alternative support links use a native disclosure. The order form is
  // immediately available and never gated behind a confirmation selector.
})();
